module.exports = __webpack_public_path__ + "img/login-logo-most.384f6eb3.png";